var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0813 3.2235L7.55737 7.798C7.40041 7.92805 7.20297 7.99922 6.99913 7.99922C6.79528 7.99922 6.59784 7.92805 6.44088 7.798L0.919625 3.2235C0.89 3.31267 0.874932 3.40604 0.875 3.5V10.5C0.875 10.7321 0.967187 10.9546 1.13128 11.1187C1.29538 11.2828 1.51794 11.375 1.75 11.375H12.25C12.4821 11.375 12.7046 11.2828 12.8687 11.1187C13.0328 10.9546 13.125 10.7321 13.125 10.5V3.5C13.1253 3.40608 13.1106 3.31272 13.0813 3.2235ZM1.75 1.75H12.25C12.7141 1.75 13.1592 1.93437 13.4874 2.26256C13.8156 2.59075 14 3.03587 14 3.5V10.5C14 10.9641 13.8156 11.4092 13.4874 11.7374C13.1592 12.0656 12.7141 12.25 12.25 12.25H1.75C1.28587 12.25 0.840752 12.0656 0.512563 11.7374C0.184374 11.4092 0 10.9641 0 10.5V3.5C0 3.03587 0.184374 2.59075 0.512563 2.26256C0.840752 1.93437 1.28587 1.75 1.75 1.75ZM1.56625 2.625L6.44525 6.65263C6.60151 6.78169 6.79773 6.85251 7.0004 6.85299C7.20308 6.85347 7.39963 6.78358 7.5565 6.65525L12.4845 2.625H1.56625Z",
    fill: "#897E7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.393a6e85dc2d7bc9a6a9d4a87b525c8b.svg";
export { ForwardRef as ReactComponent };